
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eligibility-quiz/[pageUrl]",
      function () {
        return require("private-next-pages/eligibility-quiz/[pageUrl].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eligibility-quiz/[pageUrl]"])
      });
    }
  